import React from 'react';

// Media //
import banner_2_desktop from '../media/Banner2.jpg';
import banner_2_mobile from '../media/Banner2_mobile.jpg';

import logo from '../media/logo_inverse.png';

function HeroSection() {
  return (
    <>
      <section className="container relative w-full mx-auto overflow-hidden bg-gray-900">
        <img src={banner_2_desktop} alt="" className="hidden md:block" />
        <div className="absolute inset-0 flex items-center justify-center w-full h-full bg-black/50">
          <div className="absolute flex flex-col items-center">
            <img src={logo} alt="" className="w-56 xl:w-80 lg:w-64" />
            <p className="mt-8 text-2xl font-bold text-center text-blue-500 xl:text-4xl lg:text-3xl">
              Pursuing e-motion
            </p>
            <p className="text-xl text-center text-white xl:text-3xl lg:text-2xl">
              true research
            </p>
          </div>
        </div>
        <img src={banner_2_mobile} alt="" className="w-full md:hidden" />
      </section>

      {/* --- ORIGINALE ---
      <section className="w-full bg-gray-800">
        <section
          class="container mx-auto relative bg-center bg-no-repeat bg-cover min-h-full"
          style={{ backgroundImage: `url(${banner_2_desktop})` }}
        >
          <div class="absolute inset-0 bg-black/75 sm:bg-transparent sm:bg-gradient-to-r sm:from-black/75 sm:to-transparent"></div>
          <div class="container relative px-4 py-32 mx-auto max-w-screen-xl sm:px-6 lg:px-8 lg:h-full lg:items-center lg:flex">
            <div class="max-w-xl text-center sm:text-left text-white"></div>
          </div>
        </section>
      </section>
      --- FINE --- */}
    </>
  );
}

export default HeroSection;
